module.exports = __webpack_public_path__ + "img/twitter.6a78298d.svg";